export default {"src":"/_next/static/image/public/images/ic_lab_report_ready.8c29a9b81037447d16853103473b8732.svg","height":14,"width":14};